WiseMetering.Views.SiteDocumentModalShow = WiseMetering.Views.Modal.Show.extend({
    template: 'templates/site_documents/show',
    className: 'mbx-info text-left',
    form_prefix: 'site_document',
    width: 600,
    title: () => i18next.t('modal.title.site_documents.show'),

    ui: {
        fileLink: '#file-link'
    },

    events: {
        'click #edit': 'edit'
    },

    buttons: function() {
        const buttons = ['close'];
        if (WiseMetering.currentUser.get('administrator')) {
            buttons.push('edit');
        }
        return buttons;
    },

    edit: function() {
        new WiseMetering.Views.EditSiteDocument({ model: this.model });
    },

    serializeData: function() {
        const
            json = this.model.toJSON();

        json.created_at = WiseMetering.utils.formatDate(this.model.get('created_at'));
        json.creatorName = json.creator_name;
        json.description = !json.description ? '-' : json.description;
        json.file_link = WiseMetering.apiUrl + this.model.url() + '/file';
        json.updaterName = json.updater_name;
        json.updated_at = WiseMetering.utils.formatDate(this.model.get('updated_at'));

        return json;
    }
});
